import React, { useEffect } from 'react';
// import Project from './Project';
import { connect } from 'react-redux';
import { removeProject } from './actions.js';
import NewProjectForm from './NewProjectForm';

const ProjectList = ({ projects = [], onRemovePressed }) => {

    const [showForm, setShowForm] = React.useState(false);
    useEffect(() => {
        if (projects?.length <= 0) {
            setShowForm(true);
            return;
        }
        setShowForm(false);
    }, [projects]);

    return (
        <div>
            {showForm && <NewProjectForm />}
            {projects?.length > 0 &&
                (
                    <div className="mb-3"
                        style={{ marginTop: 20, borderTop: '1px solid #e0e0e0' }}
                    >
                        <table className='table table-bordered'>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Role</th>
                                    <th>Team Size</th>
                                    <th>Url</th>
                                    <th>Github Link</th>
                                    <th>Document</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {projects.map((project, key) => (
                                    <tr key={key}>
                                        <td>{project.project.name}</td>
                                        <td>{project.project.start_date}</td>
                                        <td>{project.project.end_date}</td>
                                        <td>{project.project.role}</td>
                                        <td>{project.project.teamSize}</td>
                                        <td>
                                            {
                                                project.project.url ? <a href={project.project.url} target="_blank" rel="noopener noreferrer"> View </a> : 'No Url'
                                            }
                                        </td>
                                        <td>
                                            {
                                                project.project.githubUrl ? <a href={project.project.githubUrl} target="_blank" rel="noopener noreferrer"> View </a> : 'No Github Link'
                                            }
                                        </td>
                                        <td>
                                            <a
                                                href={project.project.document}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="blue" class="bi bi-file-earmark-pdf" viewBox="0 0 16 16">
                                                    <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                                    <path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z" />
                                                </svg>
                                                <span style={{ marginLeft: 5 }}>View</span>
                                            </a>
                                        </td>
                                        <td>
                                            <button
                                                className="btn btn-danger btn-sm rounded-circle"
                                                style={{ margin: 0 }}
                                                onClick={() => onRemovePressed(project.project)}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                </svg>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )
            }
            {
                !showForm && <div style={{ display: 'flex', justifyContent: 'end' }}>
                    <button
                        className="btn btn-primary"
                        onClick={() => setShowForm(true)}
                        style={{ display: 'flex', alignItems: 'center' }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus" viewBox="0 0 16 16">
                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                        </svg>
                        <span style={{ marginLeft: 5 }}>Add Project</span>
                    </button>
                </div>
            }
            {/* <div className="container mb-3">
                {project.map(project => (
                    <h1>{project.project.name}</h1>
                ))}
            </div> */}
        </div>
    )
}

const mapStateToProps = state => ({
    projects: state.projects,
});

const mapDispatchToProps = dispatch => ({
    onRemovePressed: project => dispatch(removeProject(project)),
});


export default connect(mapStateToProps, mapDispatchToProps)(ProjectList);